//import React from "react";
import CondesaIcon from "../assets/hotel-condesa.png";

const Condesa = () => {
  const url = "https://hotelcondesa.com/";

  // Al hacer clic, abre la URL en nueva pestaña de forma segura
  const handleClick = () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="button-styles hover-text"
      aria-label="Hotel Condesa"
    >
      <span className="tooltip-text-web fade">
        Web Site
      </span>
      <img
        src={CondesaIcon}
        alt="Logo Hotel Condesa"
        style={{ width: "185px", height: "60px", objectFit: "cover" }}
      />
    </button>
  );
};

export default Condesa;
